export enum FeatureToggle {
  ApprovalsManagementAdmin = 'rt_ipp_approvals_management_admin',
}
